import { injectable } from 'inversify';
import { HttpClient } from '../configs/axios.config';
import { AvailableCourseModel, CourseModel } from '../interfaces/models/CourseModel';
import { Api } from './Api';

@injectable()
export class CourseApi implements Api {

    constructor(
        public api: HttpClient
    ) {}

    getAvailableCourses() {
        return this.api.client.get<CourseModel[]>(`/membership/courses/`);
    }

    getCourses() {
        return this.api.client.get<CourseModel[]>(`/auth/courses/`);
    }

    getTutorial(id) {
        return this.api.client.get<any[]>(`/course/tutorial/?course=${id}`);
    }

    getCourseSize(id: number) {
        return this.api.client.get<{ size: number; items: number }>(`/sync/size/?course=${id}`);
    }

}
